import Device from "../views/Asset/Device.vue"

const getters = {
  baseUrl: state => state.config.baseUrl,
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,

  errorLogs: state => state.errorLog.logs,
  visitedRoutes: state => state.tabsBar.visitedRoutes,  

  userInfo: state => state.demo.userInfo,
  corpId: state => state.demo.corpId,
  agentId: state => state.demo.agentId,
  deptId: state => state.demo.deptId,
  projectList: state => state.demo.projectList,
  costType: state => state.demo.costType,
  assetTypeList: state => state.demo.assetTypeList,
  userProjectList: state => state.demo.userProjectList,
  // 过滤掉已竣工的项目，用于财务审批单新增时的项目选择
  userProjectListActive: state => state.demo.userProjectList.filter(project => !project.completed),
  userProjectListLevel1: state => state.demo.userProjectListLevel1,
  yearList: state => state.demo.yearList,
  monthList: state => state.demo.monthList,

  userId: state => state.user.userId,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => [], // state.user.roles
  menuList: state => state.user.menuList,
  
  permission_routes: state => state.permission.routes,

  // const
  tabTitleList: state => state.const.tabTitleList,
  dialogTitleMap: state => state.const.dialogTitleMap,
  MenuType: state => state.const.MenuType,
  OptionType: state => state.const.OptionType,
  WorkFlowStatus: state => state.const.WorkFlowStatus,
  WorkFlowStatusFilter: state => state.const.WorkFlowStatusFilter,
  PaymentMethodList: state => state.const.PaymentMethodList,
  ProjectAuthType: state => state.const.ProjectAuthType,
  DeviceStatus: state => state.const.DeviceStatus,
  DeviceOperation: state => state.const.DeviceOperation,
}
export default getters
